export default {
  // Debugging
  debugger: true, // values: true or false
}



// WEBPACK FOOTER //
// ./src/config/index.js